var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g3, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _g4, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _g5, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g6, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _g7, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _g8, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _g9, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHero = function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 895 762"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m497.915 268.047-.434-.731 94.382-54.908.217.108 97.551 53.526-.434.759-97.307-53.418z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M400.398 529.067 359.573 505.5v47.134l40.825 23.567 40.824-23.567V505.5z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 576.201-40.825-23.567V505.5l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 552.634 400.4 576.201v-47.134l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 529.067-40.825-23.566 40.825-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 529.068-39.037-22.537-1.788 1.029 40.825 23.567 40.824-23.567-1.76-1.029z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 559.325-40.798-23.567v47.134l40.798 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 606.458-40.798-23.566v-47.134l40.798 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 582.892-40.825 23.566v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 559.325-40.798-23.566 40.798-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 559.326-39.037-22.538-1.761 1.003 40.798 23.566 40.824-23.566-1.761-1.003z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 589.582-40.825-23.566v47.133l40.825 23.54 40.797-23.54v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 636.689-40.825-23.54v-47.133l40.825 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m547.25 613.149-40.798 23.54v-47.107l40.798-23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 589.583-40.825-23.567 40.797-23.567 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m506.45 589.582-39.064-22.564-1.761 1.029 40.825 23.567 40.797-23.567v-2.031z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 561.356-40.824-23.566v47.133l40.824 23.567 40.825-23.567V537.79z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 608.49-40.824-23.567V537.79l40.824 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 584.923-40.824 23.567v-47.134l40.824-23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 561.357-40.824-23.567 40.824-23.54 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 561.357-39.036-22.537-1.788 1.029 40.824 23.567 40.825-23.567-1.788-1.029z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 591.614-40.825-23.567v47.133l40.825 23.567 40.824-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 638.747-40.825-23.567v-47.133l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 615.18 400.4 638.747v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 591.614-40.825-23.567 40.825-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 591.614-39.037-22.537-1.788 1.029 40.825 23.567 40.824-23.567-1.76-1.029z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 621.871-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 669.005-40.798-23.567v-47.133l40.798 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 645.438-40.825 23.567v-47.134l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 621.872-40.798-23.567 40.798-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 621.871-39.037-22.537-1.761 1.002 40.798 23.567 40.824-23.567v-2.031z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 593.673-40.825-23.567v47.106l40.825 23.567 40.824-23.567v-47.106z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 640.779-40.825-23.567v-47.106l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m335.192 617.212-40.825 23.567v-47.106l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 593.673-40.825-23.567 40.825-23.566 40.797 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m294.365 593.673-40.825-23.567v2.032l40.825 23.566 40.797-23.566-1.761-1.03z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 623.902-40.824-23.566v47.133l40.824 23.567 40.825-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 671.036-40.824-23.567v-47.133l40.824 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 647.469-40.824 23.566v-47.133l40.824-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 623.903-40.824-23.567 40.824-23.567 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 623.902-40.824-23.566v2.058l40.824 23.567 40.825-23.567-1.788-1.029z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 654.161-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 701.294-40.825-23.566v-47.134l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 677.728 400.4 701.294v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 654.161-40.825-23.567 40.825-23.566 40.824 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 654.161-40.825-23.567v2.059l40.825 23.567 40.824-23.567v-2.059z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 466.521-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 513.654-40.825-23.566v-47.134l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 490.087 400.4 513.654v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 466.521-40.825-23.566 40.825-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 466.522-39.037-22.538-1.788 1.03 40.825 23.566 40.824-23.566-1.76-1.03z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18B2A3",
    d: "m400.398 646.495-27.848-16.09 27.848-16.064 27.849 16.064zm-53.018-30.258-27.849-16.063 27.849-16.09 27.848 16.09zm106.031-2.058-27.849-16.063 27.849-16.064 27.848 16.064zm53.123-31.91-27.848-16.063 27.848-16.091 27.849 16.091zm-212.169 3.711-27.848-16.064 27.848-16.09 27.849 16.09z",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 496.778-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 543.912-40.798-23.567v-47.133l40.798 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 520.345-40.825 23.566v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 496.779-40.798-23.567 40.798-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 496.779-39.037-22.537-1.761 1.029 40.798 23.54 40.824-23.54-1.761-1.029z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 527.035-40.825-23.566v47.133l40.825 23.567 40.797-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 574.169-40.825-23.567v-47.133l40.825 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m547.25 550.602-40.798 23.567v-47.134l40.798-23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 527.036-40.825-23.567 40.797-23.567 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m506.45 527.035-39.064-22.537-1.761 1.002 40.825 23.567 40.797-23.567v-2.031z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 498.837-40.824-23.567v47.107l40.824 23.566 40.825-23.566V475.27z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 545.943-40.824-23.566V475.27l40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 522.376-40.824 23.567v-47.106l40.824-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 498.837-40.824-23.566 40.824-23.567 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 498.838-39.036-22.565-1.788 1.03 40.824 23.566 40.825-23.566-1.788-1.03z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M400.398 529.067 359.573 505.5v47.134l40.825 23.567 40.824-23.567V505.5z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 576.201-40.825-23.567V505.5l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 552.634 400.4 576.201v-47.134l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 529.067-40.825-23.566 40.825-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 529.068-39.037-22.537-1.788 1.029 40.825 23.567 40.824-23.567-1.76-1.029z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 559.325-40.798-23.567v47.134l40.798 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 606.458-40.798-23.566v-47.134l40.798 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 582.892-40.825 23.566v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 559.325-40.798-23.566 40.798-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 559.325-39.037-22.537-1.761 1.002 40.798 23.567 40.824-23.54v-2.059z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 531.126-40.825-23.567v47.133l40.825 23.567 40.824-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 578.259-40.825-23.567v-47.133l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m335.192 554.692-40.825 23.567v-47.134l40.825-23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 531.126-40.825-23.567 40.825-23.567 40.797 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m294.365 531.126-39.064-22.564-1.761 1.029 40.825 23.567 40.797-23.567-1.761-1.002z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 561.356-40.824-23.566v47.133l40.824 23.567 40.825-23.567V537.79z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 608.49-40.824-23.567V537.79l40.824 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 584.923-40.824 23.567v-47.134l40.824-23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 561.357-40.824-23.567 40.824-23.54 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 561.356-40.824-23.566v2.059l40.824 23.566 40.825-23.566-1.788-1.03z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 591.614-40.825-23.567v47.133l40.825 23.567 40.824-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 638.747-40.825-23.567v-47.133l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 615.18 400.4 638.747v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 591.614-40.825-23.567 40.825-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 591.614-40.825-23.567v2.059l40.825 23.566 40.824-23.566v-2.059z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18B2A3",
    d: "m506.534 519.994-27.848-16.064 27.848-16.09 27.849 16.09zm-212.169 3.738-27.848-16.091 27.848-16.063 27.849 16.063z",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 403.974-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 451.107-40.825-23.566v-47.134l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 427.541 400.4 451.107v-47.133l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 403.974-40.825-23.566 40.825-23.54 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 403.974-40.825-23.567v2.059l40.825 23.567 40.824-23.567v-2.059z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 434.231-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 481.365-40.798-23.567v-47.133l40.798 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 457.798-40.825 23.567v-47.134l40.825-23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 434.232-40.798-23.567 40.798-23.567 40.824 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 434.231-40.798-23.566v2.058l40.798 23.567 40.824-23.567v-2.058z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 464.489-40.825-23.566v47.133l40.825 23.567 40.797-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 511.623-40.825-23.567v-47.133l40.825 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m547.25 488.056-40.798 23.566v-47.133l40.798-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 464.49-40.825-23.567 40.797-23.567 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m506.45 464.489-40.825-23.566v2.031l40.825 23.567 40.797-23.567v-2.031z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 436.29-40.824-23.566v47.106l40.824 23.567 40.825-23.567v-47.106z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 483.397-40.824-23.567v-47.106l40.824 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 459.83-40.824 23.566V436.29l40.824-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 436.291-40.824-23.567 40.824-23.567 40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 436.29-40.824-23.566v2.031l40.824 23.567 40.825-23.567v-2.031z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 468.58-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 515.713-40.825-23.566v-47.134l40.825 23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m335.192 492.147-40.825 23.566V468.58l40.825-23.567z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 468.58-40.825-23.567 40.825-23.566 40.797 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m294.365 468.58-40.825-23.567v2.032l40.825 23.567 40.797-23.567.027-2.032z",
    opacity: 0.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#AEB1C1",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m455.114 588.825-28.471-16.443c-4.877-2.817-8.859-9.697-8.859-15.359v-6.853c0-5.363-3.792-11.919-8.425-14.6l-5.96-3.441.434-.731 5.96 3.44c4.876 2.817 8.858 9.725 8.858 15.359v6.853c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.192 582.432-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442zm11.079-6.392L448.8 559.597c-4.876-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.353 569.673-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.853c0-5.363-3.792-11.919-8.425-14.6l-5.959-3.441.433-.731 5.96 3.44c4.876 2.817 8.858 9.725 8.858 15.359v6.854c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.406 563.281-28.471-16.442c-4.877-2.818-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.919-8.425-14.6l-5.96-3.44.434-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.486 556.915-28.471-16.443c-4.877-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.363-3.792-11.919-8.425-14.601l-5.96-3.44.434-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.563 550.522-28.471-16.442c-4.876-2.818-8.859-9.698-8.859-15.359v-6.854c0-5.363-3.792-11.918-8.425-14.6l-5.959-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.725 8.858 15.359v6.854c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.642 544.129-28.472-16.442c-4.876-2.817-8.858-9.698-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m543.729 537.763-28.471-16.442c-4.876-2.817-8.859-9.698-8.859-15.359v-6.88c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.774 531.371-28.471-16.442c-4.876-2.818-8.859-9.698-8.859-15.359v-6.854c0-5.363-3.792-11.918-8.425-14.6l-5.959-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.36v6.853c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m565.86 525.005-28.471-16.443c-4.877-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.363-3.792-11.919-8.425-14.6l-5.959-3.441.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.94 518.613-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.853c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.853c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m588.017 512.247-28.471-16.443c-4.876-2.817-8.858-9.697-8.858-15.359v-6.853c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.853c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.096 505.853-28.472-16.442c-4.876-2.817-8.858-9.698-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.732 5.96 3.441c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610.15 499.461-28.471-16.442c-4.876-2.817-8.859-9.698-8.859-15.359v-6.854c0-5.363-3.792-11.918-8.425-14.6l-5.959-3.44.433-.732 5.96 3.441c4.876 2.817 8.858 9.697 8.858 15.359v6.853c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m621.228 493.096-28.471-16.443c-4.876-2.817-8.859-9.698-8.859-15.359v-6.88c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.31 486.703-28.471-16.443c-4.876-2.817-8.858-9.697-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m643.389 480.337-28.471-16.443c-4.876-2.817-8.858-9.697-8.858-15.358v-6.854c0-5.363-3.793-11.919-8.425-14.6l-5.96-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.854c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.47 473.944-28.472-16.442c-4.876-2.817-8.858-9.698-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.732 5.96 3.441c4.876 2.817 8.859 9.697 8.859 15.359v6.88c0 5.363 3.792 11.919 8.424 14.601l28.472 16.442z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m665.549 467.578-28.472-16.442c-4.876-2.817-8.858-9.698-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.731 5.96 3.44c4.876 2.817 8.859 9.697 8.859 15.359v6.88c0 5.363 3.792 11.919 8.425 14.601l28.471 16.442z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#AEB1C1",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.885 588.825-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.853c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.441c-4.66 2.681-8.425 9.237-8.425 14.6v6.853c0 5.635-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.832 582.432-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.434.731-5.96 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.88c0 5.635-3.982 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.752 576.039-.434-.731 28.472-16.442c4.659-2.682 8.425-9.238 8.425-14.601v-6.88c0-5.635 3.982-12.542 8.858-15.359l5.96-3.441.434.732-5.96 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.88c0 5.634-3.982 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.672 569.673-.434-.731L339.71 552.5c4.659-2.682 8.425-9.237 8.425-14.601v-6.853c0-5.635 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.982 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.591 563.281-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.88c0 5.634-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.513 556.915-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.88c0 5.634-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.46 550.522-.434-.731 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.854c0-5.634 3.982-12.541 8.858-15.359l5.96-3.44.434.732-5.96 3.44c-4.66 2.682-8.425 9.237-8.425 14.6v6.854c0 5.634-3.982 12.541-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.382 544.129-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.541 8.858-15.359l5.96-3.44.433.732-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.6v6.881c0 5.634-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.303 537.763-.434-.731 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.441c-4.66 2.681-8.425 9.237-8.425 14.6v6.881c0 5.634-3.983 12.541-8.859 15.358z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.223 531.371-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.6v-6.854c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.96 3.441c-4.659 2.681-8.425 9.237-8.425 14.6v6.853c0 5.635-3.982 12.542-8.858 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.137 525.005-.434-.731 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.441c-4.66 2.681-8.425 9.237-8.425 14.6v6.88c0 5.635-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.056 518.612-.433-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.853c0-5.635 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.982 12.542-8.858 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.004 512.246-.434-.731 28.472-16.442c4.659-2.682 8.425-9.238 8.425-14.601v-6.853c0-5.635 3.982-12.542 8.858-15.359l5.96-3.44.434.731-5.96 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.982 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.926 505.853-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.88c0-5.635 3.982-12.542 8.858-15.359l5.96-3.441.433.732-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.88c0 5.634-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.848 499.461-.433-.731 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.854c0-5.634 3.982-12.541 8.858-15.359l5.96-3.44.433.732-5.96 3.44c-4.659 2.681-8.425 9.237-8.425 14.6v6.854c0 5.634-3.982 12.541-8.858 15.358z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.768 493.095-.433-.732 28.471-16.442c4.66-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.88c0 5.635-3.982 12.542-8.858 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.687 486.703-.433-.731 28.499-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.96 3.441c-4.659 2.681-8.425 9.237-8.425 14.6v6.88c0 5.635-3.982 12.542-8.858 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.634 480.337-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.853c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m145.555 473.944-.434-.731 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.96 3.441c-4.659 2.681-8.424 9.237-8.424 14.6v6.88c0 5.635-3.983 12.542-8.859 15.359z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.476 467.578-.433-.758 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.541 8.858-15.359l5.96-3.44.433.732-5.96 3.44c-4.659 2.681-8.425 9.237-8.425 14.6v6.881c0 5.634-3.982 12.541-8.858 15.359z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__a)",
    d: "M619.198 421.013v25.3L400.393 572.625 181.587 446.286v-25.273z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCBEFF",
    d: "M400.393 547.325 181.587 421.013l218.806-126.312 218.805 126.312z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M400.393 544.372 184.16 419.55l-2.573 1.463 218.806 126.312 218.805-126.312-2.573-1.463z",
    opacity: 0.2
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M377.614 258.62c-1.273 0-2.655-.406-4.091-1.246l-28.471-16.442.433-.732 28.472 16.443c2.167 1.246 4.199 1.463 5.689.596s2.329-2.709 2.329-5.228v-6.854c0-2.817.976-4.957 2.736-5.986s4.091-.813 6.556.596l5.96 3.44-.433.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.854c0 2.817-.975 4.957-2.736 5.986-.731.433-1.571.65-2.465.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M366.535 264.986c-1.246 0-2.655-.406-4.091-1.246l-28.471-16.443.433-.731 28.472 16.442c2.167 1.247 4.199 1.463 5.689.596 1.489-.866 2.329-2.708 2.329-5.228v-6.853c0-2.817.976-4.957 2.736-5.959 1.761-1.03 4.091-.813 6.556.596l5.96 3.44-.434.731-5.959-3.44c-2.168-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.853c0 2.818-.975 4.958-2.736 5.987a5.05 5.05 0 0 1-2.465.623"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M355.455 271.351c-1.274 0-2.655-.406-4.091-1.246l-28.471-16.442.433-.732 28.472 16.443c2.167 1.246 4.199 1.463 5.688.596 1.49-.867 2.33-2.709 2.33-5.228v-6.881c0-2.817.975-4.957 2.736-5.959 1.761-1.029 4.091-.813 6.556.596l5.96 3.44-.434.732-5.959-3.441c-2.168-1.246-4.199-1.462-5.689-.596-1.49.867-2.33 2.709-2.33 5.228v6.881c0 2.817-.975 4.957-2.736 5.959-.732.434-1.544.65-2.465.65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M344.402 277.718c-1.273 0-2.655-.407-4.091-1.246l-28.471-16.443.433-.731 28.472 16.442c2.167 1.246 4.199 1.463 5.689.596s2.329-2.709 2.329-5.228v-6.88c0-2.817.976-4.957 2.737-5.96 1.76-1.029 4.09-.812 6.555.596l5.96 3.44-.433.732-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.959-.731.434-1.571.651-2.465.651"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M333.32 284.083c-1.273 0-2.655-.407-4.091-1.246l-28.471-16.443.433-.731 28.472 16.442c2.167 1.246 4.199 1.463 5.689.596s2.329-2.708 2.329-5.228v-6.88c0-2.817.976-4.957 2.737-5.959 1.76-1.03 4.09-.813 6.555.596l5.96 3.44-.433.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.96-.731.46-1.571.65-2.465.65"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M322.241 290.476c-1.246 0-2.655-.407-4.063-1.246l-28.472-16.443.434-.731 28.471 16.442c2.167 1.246 4.199 1.463 5.689.596s2.33-2.709 2.33-5.228v-6.88c0-2.817.975-4.957 2.736-5.96 1.761-1.029 4.09-.812 6.556.596l5.959 3.441-.433.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.96a4.96 4.96 0 0 1-2.492.65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M311.163 296.842c-1.274 0-2.655-.407-4.091-1.246l-28.471-16.443.433-.731 28.472 16.442c2.167 1.246 4.198 1.463 5.688.596 1.49-.866 2.33-2.708 2.33-5.228v-6.88c0-2.817.975-4.957 2.736-5.959 1.761-1.03 4.091-.813 6.556.596l5.96 3.44-.434.731-5.959-3.44c-2.168-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.96-.732.433-1.571.65-2.465.65"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M300.084 303.207c-1.246 0-2.655-.406-4.064-1.246l-28.471-16.442.433-.732 28.472 16.443c2.167 1.246 4.199 1.462 5.689.596 1.49-.867 2.329-2.709 2.329-5.228v-6.854c0-2.817.976-4.957 2.737-5.959 1.76-1.029 4.09-.813 6.555.596l5.96 3.44-.433.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.854c0 2.817-.975 4.957-2.736 5.959a4.9 4.9 0 0 1-2.492.65"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M289.032 309.573c-1.273 0-2.655-.406-4.091-1.246l-28.471-16.442.433-.732 28.472 16.443c2.167 1.246 4.199 1.462 5.689.596 1.49-.867 2.329-2.709 2.329-5.228v-6.854c0-2.817.976-4.957 2.736-5.986 1.761-1.03 4.091-.813 6.556.596l5.96 3.44-.433.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.853c0 2.818-.975 4.958-2.736 5.987a4.86 4.86 0 0 1-2.465.65"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M277.952 315.938c-1.246 0-2.655-.406-4.091-1.246L245.39 298.25l.433-.732 28.472 16.443c2.167 1.246 4.199 1.463 5.689.596 1.489-.867 2.329-2.709 2.329-5.228v-6.853c0-2.818.976-4.958 2.736-5.96 1.761-1.029 4.091-.813 6.556.596l5.96 3.44-.434.732-5.959-3.441c-2.167-1.246-4.199-1.462-5.689-.596-1.49.867-2.33 2.709-2.33 5.229v6.853c0 2.817-.975 4.957-2.736 5.986a5.04 5.04 0 0 1-2.465.623"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M266.866 322.304c-1.273 0-2.655-.406-4.091-1.246l-28.471-16.442.433-.732 28.472 16.443c2.167 1.246 4.199 1.463 5.689.596s2.329-2.709 2.329-5.228v-6.881c0-2.817.976-4.957 2.736-5.959 1.761-1.029 4.091-.813 6.556.596l5.96 3.44-.433.731-5.96-3.44c-2.167-1.246-4.199-1.462-5.689-.596-1.49.867-2.33 2.709-2.33 5.228v6.881c0 2.817-.975 4.957-2.736 5.959-.731.461-1.571.65-2.465.65"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M255.786 328.67c-1.273 0-2.655-.406-4.091-1.246l-28.471-16.442.433-.731 28.472 16.442c2.167 1.246 4.199 1.463 5.689.596 1.489-.867 2.329-2.709 2.329-5.228v-6.88c0-2.818.975-4.958 2.736-5.96 1.761-1.029 4.091-.812 6.556.596l5.96 3.44-.434.732-5.959-3.44c-2.168-1.247-4.199-1.463-5.689-.596-1.49.866-2.33 2.708-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.959-.731.461-1.571.65-2.465.65"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M244.709 335.063c-1.274 0-2.655-.407-4.091-1.246l-28.472-16.443.434-.731 28.472 16.442c2.167 1.246 4.198 1.463 5.688.596s2.33-2.709 2.33-5.228v-6.88c0-2.817.975-4.957 2.736-5.96 1.761-1.029 4.091-.812 6.556.596l5.96 3.44-.434.732-5.959-3.44c-2.168-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.959-.732.434-1.571.651-2.465.651"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M233.656 341.429c-1.273 0-2.655-.407-4.091-1.246l-28.471-16.443.433-.731 28.472 16.442c2.167 1.246 4.199 1.463 5.689.596s2.329-2.708 2.329-5.228v-6.88c0-2.817.976-4.957 2.736-5.959 1.761-1.03 4.091-.813 6.556.595l5.96 3.441-.433.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.96a4.86 4.86 0 0 1-2.465.65"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M222.578 347.794c-1.273 0-2.655-.406-4.091-1.246l-28.471-16.442.433-.732 28.472 16.443c2.167 1.246 4.199 1.463 5.689.596 1.489-.867 2.329-2.709 2.329-5.228v-6.881c0-2.817.976-4.957 2.736-5.959 1.761-1.029 4.091-.813 6.556.596l5.96 3.44-.434.731-5.959-3.44c-2.168-1.246-4.199-1.462-5.689-.596-1.49.867-2.33 2.709-2.33 5.228v6.881c0 2.817-.975 4.957-2.736 5.959-.731.434-1.571.65-2.465.65"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M211.496 354.16c-1.273 0-2.655-.407-4.091-1.246l-28.471-16.443.433-.731 28.472 16.442c2.167 1.246 4.199 1.463 5.688.596 1.49-.867 2.33-2.709 2.33-5.228v-6.853c0-2.817.975-4.957 2.736-5.987 1.761-1.029 4.091-.812 6.556.596l5.96 3.441-.434.731-5.959-3.44c-2.168-1.246-4.199-1.463-5.689-.596s-2.33 2.709-2.33 5.228v6.853c0 2.817-.975 4.957-2.736 5.987-.732.433-1.571.65-2.465.65"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M200.417 360.525c-1.274 0-2.655-.406-4.091-1.246l-28.472-16.415.434-.732 28.471 16.443c2.168 1.246 4.199 1.463 5.689.596s2.33-2.709 2.33-5.228v-6.853c0-2.818.975-4.958 2.736-5.987s4.091-.813 6.556.596l5.96 3.44-.434.732-5.959-3.441c-2.168-1.246-4.199-1.462-5.689-.596-1.49.867-2.33 2.709-2.33 5.228v6.854c0 2.817-.975 4.957-2.736 5.986-.732.434-1.571.623-2.465.623"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M189.337 366.919c-1.274 0-2.655-.407-4.091-1.246l-28.472-16.443.434-.731 28.471 16.442c2.168 1.246 4.199 1.463 5.689.596s2.33-2.709 2.33-5.228v-6.88c0-2.817.975-4.957 2.736-5.96 1.761-1.029 4.091-.812 6.556.596l5.96 3.441-.434.731-5.96-3.44c-2.167-1.246-4.198-1.463-5.688-.596s-2.33 2.709-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.96-.732.433-1.571.65-2.465.65"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M178.258 373.285c-1.273 0-2.654-.407-4.09-1.246l-28.472-16.443.434-.731 28.471 16.442c2.167 1.246 4.199 1.463 5.689.596s2.33-2.709 2.33-5.228v-6.88c0-2.817.975-4.957 2.736-5.96 1.761-1.029 4.091-.812 6.556.596l5.96 3.441-.434.731-5.96-3.44c-2.167-1.246-4.199-1.463-5.689-.596s-2.329 2.709-2.329 5.228v6.88c0 2.817-.976 4.957-2.736 5.96-.732.433-1.545.65-2.466.65"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M167.206 379.65c-1.274 0-2.655-.407-4.091-1.247l-28.471-16.442.433-.731 28.472 16.442c2.167 1.246 4.199 1.463 5.688.596 1.49-.867 2.33-2.709 2.33-5.228v-6.88c0-2.818.975-4.958 2.736-5.96 1.761-1.029 4.091-.812 6.556.596l5.96 3.44-.434.732-5.959-3.44c-2.168-1.247-4.199-1.463-5.689-.596-1.49.866-2.33 2.708-2.33 5.228v6.88c0 2.817-.975 4.957-2.736 5.959-.732.434-1.571.651-2.465.651m255.781-120.515c-.894 0-1.734-.217-2.465-.65-1.761-1.03-2.736-3.142-2.736-5.96v-6.88c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.522-.65-5.689.596l-5.96 3.44-.433-.731 5.96-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.76 1.029 2.736 3.142 2.736 5.959v6.88c0 2.52.812 4.362 2.329 5.228 1.49.867 3.522.65 5.689-.596l28.472-16.442.433.731-28.471 16.443c-1.436.812-2.818 1.246-4.091 1.246"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M434.065 265.501c-.894 0-1.733-.217-2.465-.65-1.761-1.03-2.736-3.143-2.736-5.96v-6.88c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.731 5.96-3.441c2.438-1.408 4.768-1.625 6.556-.595 1.761 1.029 2.736 3.142 2.736 5.959v6.88c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.688-.596l28.472-16.442.433.731-28.471 16.443c-1.436.839-2.817 1.246-4.091 1.246"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M445.144 271.866c-.894 0-1.733-.217-2.465-.65-1.761-1.03-2.736-3.143-2.736-5.96v-6.853c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.731 5.96-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.986v6.853c0 2.52.813 4.362 2.33 5.228 1.49.867 3.521.651 5.689-.596l28.471-16.442.434.731-28.472 16.443c-1.436.813-2.844 1.219-4.091 1.219"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M456.226 278.232a5.05 5.05 0 0 1-2.465-.623c-1.761-1.029-2.736-3.142-2.736-5.986v-6.854c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.688.596l-5.96 3.44-.434-.731 5.96-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.986v6.854c0 2.519.813 4.361 2.33 5.228 1.49.866 3.521.65 5.689-.596l28.471-16.443.434.732-28.472 16.442c-1.463.813-2.844 1.219-4.091 1.219"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M467.306 284.625a5.06 5.06 0 0 1-2.465-.623c-1.761-1.029-2.736-3.142-2.736-5.986v-6.854c0-2.519-.812-4.361-2.33-5.228-1.489-.867-3.521-.65-5.688.596l-5.96 3.44-.434-.731 5.96-3.44c2.438-1.409 4.768-1.625 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.959v6.854c0 2.519.813 4.361 2.33 5.228 1.49.866 3.521.65 5.689-.596l28.471-16.443.434.732-28.472 16.442c-1.463.813-2.844 1.246-4.091 1.246"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M478.359 290.991a5.05 5.05 0 0 1-2.465-.623c-1.761-1.03-2.736-3.143-2.736-5.96v-6.88c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.731 5.96-3.441c2.438-1.408 4.768-1.625 6.556-.596 1.76 1.03 2.736 3.143 2.736 5.96v6.88c0 2.519.812 4.361 2.329 5.228 1.49.867 3.522.65 5.689-.596l28.472-16.442.433.731-28.471 16.443c-1.436.785-2.818 1.219-4.091 1.219"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M489.436 297.357a5.05 5.05 0 0 1-2.465-.623c-1.761-1.03-2.736-3.143-2.736-5.96v-6.88c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.732 5.96-3.44c2.438-1.408 4.768-1.625 6.556-.596 1.761 1.03 2.736 3.143 2.736 5.96v6.853c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.433.731-28.471 16.442c-1.436.84-2.817 1.247-4.091 1.247"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M500.515 303.721c-.894 0-1.734-.216-2.466-.65-1.761-1.029-2.736-3.142-2.736-5.959v-6.88c0-2.52-.812-4.362-2.329-5.228-1.49-.867-3.522-.65-5.689.596l-5.96 3.44-.434-.732 5.96-3.44c2.465-1.408 4.768-1.625 6.556-.596 1.761 1.03 2.736 3.142 2.736 5.96v6.88c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.434.731-28.472 16.442c-1.436.84-2.817 1.246-4.09 1.246"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M511.602 310.088c-.894 0-1.733-.217-2.465-.65-1.761-1.03-2.736-3.143-2.736-5.96v-6.88c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.731 5.96-3.441c2.438-1.408 4.768-1.625 6.556-.596 1.761 1.03 2.736 3.143 2.736 5.96v6.88c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.434.731-28.472 16.443c-1.436.839-2.844 1.246-4.091 1.246"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M522.68 316.453c-.893 0-1.733-.217-2.465-.65-1.761-1.03-2.736-3.142-2.736-5.96v-6.88c0-2.519-.812-4.361-2.33-5.228-1.489-.867-3.521-.65-5.688.596l-5.96 3.44-.434-.731 5.96-3.44c2.465-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.959v6.88c0 2.52.813 4.362 2.33 5.228 1.49.867 3.521.651 5.689-.595l28.471-16.443.434.731-28.472 16.443c-1.463.84-2.844 1.246-4.091 1.246"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M533.733 322.846c-.894 0-1.734-.217-2.465-.65-1.761-1.029-2.736-3.142-2.736-5.959v-6.854c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.731 5.96-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.986v6.854c0 2.519.812 4.361 2.329 5.228 1.49.866 3.522.65 5.689-.596l28.472-16.443.433.732-28.471 16.442c-1.436.786-2.818 1.219-4.091 1.219"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M544.813 329.212a5.05 5.05 0 0 1-2.465-.623c-1.761-1.029-2.736-3.142-2.736-5.987v-6.853c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.689.596l-5.959 3.44-.434-.731 5.96-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.986v6.854c0 2.519.813 4.361 2.33 5.228 1.49.866 3.521.65 5.688-.596l28.472-16.443.433.732-28.471 16.442c-1.436.786-2.817 1.219-4.091 1.219"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M555.892 335.577a5.04 5.04 0 0 1-2.465-.623c-1.761-1.029-2.736-3.142-2.736-5.986v-6.853c0-2.52-.813-4.362-2.33-5.228-1.49-.867-3.521-.65-5.688.596l-5.96 3.44-.434-.732 5.96-3.44c2.438-1.408 4.768-1.625 6.556-.596 1.761 1.03 2.736 3.143 2.736 5.96v6.853c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.434.731-28.472 16.442c-1.436.84-2.817 1.246-4.091 1.246"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M566.971 341.944a5.06 5.06 0 0 1-2.466-.623c-1.76-1.03-2.736-3.143-2.736-5.96v-6.88c0-2.519-.812-4.361-2.329-5.228-1.49-.867-3.522-.65-5.689.596l-5.96 3.44-.434-.731 5.96-3.441c2.438-1.408 4.768-1.625 6.556-.595 1.761 1.029 2.736 3.142 2.736 5.959v6.88c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.434.731-28.472 16.443c-1.436.812-2.844 1.219-4.09 1.219"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M578.05 348.309a5.05 5.05 0 0 1-2.465-.623c-1.761-1.029-2.737-3.142-2.737-5.959v-6.881c0-2.519-.812-4.361-2.329-5.228-1.49-.867-3.522-.65-5.689.596l-5.96 3.44-.433-.731 5.959-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.959v6.881c0 2.519.813 4.361 2.33 5.228 1.49.866 3.522.65 5.689-.596l28.471-16.443.434.731-28.472 16.443c-1.463.813-2.844 1.219-4.09 1.219"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M589.101 354.674c-.894 0-1.733-.216-2.465-.65-1.761-1.029-2.736-3.142-2.736-5.959v-6.881c0-2.519-.813-4.361-2.33-5.227-1.49-.867-3.521-.651-5.689.595l-5.959 3.441-.434-.732 5.96-3.44c2.465-1.409 4.768-1.625 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.959v6.881c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.443.434.732-28.472 16.442c-1.436.84-2.817 1.246-4.091 1.246"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M600.183 361.068c-.894 0-1.733-.217-2.465-.65-1.761-1.03-2.736-3.143-2.736-5.96v-6.88c0-2.519-.813-4.361-2.33-5.228-1.49-.867-3.521-.65-5.688.596l-5.96 3.44-.434-.731 5.96-3.441c2.438-1.408 4.768-1.625 6.556-.596 1.788 1.03 2.736 3.143 2.736 5.96v6.88c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.434.731-28.472 16.443c-1.436.812-2.817 1.246-4.091 1.246"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M611.263 367.433c-.894 0-1.734-.217-2.466-.65-1.761-1.03-2.736-3.143-2.736-5.96v-6.853c0-2.519-.812-4.361-2.329-5.228-1.49-.867-3.522-.65-5.689.596l-5.96 3.44-.434-.731 5.96-3.441c2.438-1.408 4.768-1.625 6.556-.595 1.761 1.029 2.736 3.142 2.736 5.959v6.853c0 2.519.813 4.361 2.33 5.228 1.49.867 3.521.65 5.689-.596l28.471-16.442.434.731-28.472 16.443c-1.436.812-2.817 1.246-4.09 1.246"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M622.343 373.799a5.06 5.06 0 0 1-2.466-.623c-1.76-1.029-2.736-3.142-2.736-5.987v-6.853c0-2.519-.812-4.361-2.329-5.228-1.49-.867-3.522-.65-5.689.596l-5.96 3.44-.434-.731 5.96-3.44c2.438-1.409 4.768-1.626 6.556-.596 1.761 1.029 2.736 3.142 2.736 5.986v6.853c0 2.52.813 4.362 2.33 5.229 1.49.866 3.522.65 5.689-.596l28.471-16.443.434.731-28.472 16.443c-1.436.813-2.844 1.219-4.09 1.219"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M633.42 380.164a5.04 5.04 0 0 1-2.465-.623c-1.761-1.029-2.736-3.142-2.736-5.986v-6.853c0-2.52-.813-4.362-2.33-5.228-1.49-.867-3.522-.651-5.689.596l-5.96 3.44-.433-.732 5.959-3.44c2.439-1.408 4.768-1.625 6.556-.596 1.761 1.03 2.736 3.142 2.736 5.96v6.853c0 2.519.813 4.361 2.33 5.228 1.49.867 3.522.65 5.689-.596l28.471-16.443.434.732-28.472 16.442c-1.462.84-2.844 1.246-4.09 1.246"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__b)",
    d: "M619.198 367.596v25.273L400.393 519.208 181.587 392.869v-25.273z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4069",
    d: "M400.393 493.908 181.587 367.596l218.806-126.312 218.805 126.312z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M400.393 490.956 184.16 366.107l-2.573 1.49 218.806 126.311 218.805-126.311-2.573-1.463z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m400.398 464.788-168.283-97.165 168.283-97.138 168.283 97.138z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__c)",
    d: "M400.393 464.789 232.11 367.624l168.283-97.138 168.283 97.138z",
    opacity: 0.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__d)",
    d: "m400.392 245.97 168.282 97.166v24.487l-168.282-97.165z",
    opacity: 0.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__e)",
    d: "M400.393 270.458 232.11 367.623v-24.487l168.283-97.166z",
    opacity: 0.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__f)",
    d: "M400.393 440.274 232.11 343.136l168.283-97.166 168.283 97.166z",
    opacity: 0.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.396 381.953-67.237-38.817 67.237-38.817 67.238 38.817z",
    opacity: 0.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.396 307.867 64.15 37.057 3.088-1.788-67.238-38.817-67.237 38.817 3.088 1.788z",
    opacity: 0.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__g)",
    d: "M400.392 440.274v24.515l168.282-97.166v-24.487z",
    opacity: 0.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__h)",
    d: "M232.11 343.136v24.488l168.283 97.165v-24.515z",
    opacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m400.398 437.619-165.98-95.838-2.303 1.355 168.283 97.138 168.283-97.138-2.303-1.355z",
    opacity: 0.8
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m455.116 548.896-28.471-16.442c-4.877-2.818-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.919-8.425-14.6l-5.96-3.44.434-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m466.194 542.503-28.471-16.442c-4.877-2.818-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.919-8.425-14.6l-5.96-3.441.434-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m477.273 536.138-28.471-16.442c-4.876-2.818-8.859-9.698-8.859-15.359v-6.854c0-5.363-3.792-11.919-8.425-14.6l-5.959-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.725 8.858 15.359v6.854c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m488.355 529.745-28.471-16.442c-4.876-2.818-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.918-8.425-14.6l-5.959-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m499.408 523.379-28.471-16.442c-4.877-2.817-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.918-8.425-14.6l-5.96-3.44.434-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m510.488 516.986-28.471-16.442c-4.877-2.818-8.859-9.698-8.859-15.359v-6.854c0-5.363-3.792-11.918-8.425-14.6l-5.96-3.44.434-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.854c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m521.565 510.594-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m532.643 504.228-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.363-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m543.731 497.835-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.853c0-5.363-3.792-11.919-8.425-14.6l-5.959-3.441.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.853c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m554.776 491.47-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m565.862 485.076-28.471-16.442c-4.877-2.817-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.918-8.425-14.6l-5.96-3.44.434-.732 5.96 3.441c4.876 2.817 8.858 9.697 8.858 15.358v6.881c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m576.942 478.711-28.471-16.442c-4.876-2.818-8.859-9.698-8.859-15.359v-6.854c0-5.363-3.792-11.919-8.425-14.6l-5.959-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.854c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m588.019 472.318-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.88c0-5.363-3.792-11.919-8.424-14.6l-5.96-3.441.433-.731 5.96 3.44c4.876 2.817 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m599.098 465.925-28.472-16.442c-4.876-2.817-8.858-9.698-8.858-15.359v-6.881c0-5.363-3.793-11.918-8.425-14.6l-5.96-3.44.433-.732 5.96 3.441c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m610.152 459.56-28.471-16.443c-4.876-2.817-8.859-9.697-8.859-15.359v-6.853c0-5.364-3.792-11.919-8.425-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.725 8.858 15.359v6.853c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m621.23 453.167-28.471-16.442c-4.876-2.818-8.859-9.698-8.859-15.359v-6.881c0-5.363-3.792-11.919-8.425-14.6l-5.959-3.44.433-.732 5.96 3.44c4.876 2.818 8.858 9.698 8.858 15.359v6.881c0 5.363 3.793 11.918 8.425 14.6l28.472 16.443z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m632.312 446.802-28.471-16.443c-4.876-2.817-8.858-9.697-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.426-14.601l-5.959-3.44.433-.731 5.96 3.44c4.876 2.817 8.858 9.697 8.858 15.359v6.88c0 5.364 3.793 11.919 8.425 14.601l28.472 16.442z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m643.392 440.408-28.472-16.442c-4.876-2.817-8.858-9.698-8.858-15.359v-6.853c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.732 5.96 3.441c4.876 2.817 8.858 9.724 8.858 15.359v6.853c0 5.363 3.793 11.919 8.425 14.6l28.472 16.443z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M654.472 434.043 626 417.6c-4.876-2.817-8.858-9.698-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.731 5.96 3.44c4.876 2.817 8.859 9.697 8.859 15.359v6.88c0 5.364 3.792 11.919 8.424 14.601l28.472 16.442zm11.077-6.393-28.472-16.443c-4.876-2.817-8.858-9.697-8.858-15.359v-6.88c0-5.364-3.793-11.919-8.425-14.601l-5.96-3.44.433-.731 5.96 3.44c4.876 2.817 8.859 9.698 8.859 15.359v6.88c0 5.364 3.792 11.919 8.425 14.601l28.471 16.442zm-320.66 121.246-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.88c0-5.635 3.982-12.542 8.858-15.359l5.96-3.441.433.732-5.96 3.44c-4.659 2.682-8.424 9.237-8.424 14.6v6.881c0 5.634-3.983 12.542-8.859 15.359z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m333.835 542.503-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.541 8.858-15.358l5.96-3.441.434.732-5.96 3.44c-4.66 2.682-8.425 9.237-8.425 14.6v6.881c0 5.634-3.982 12.542-8.859 15.359z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m322.756 536.138-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.853c0-5.635 3.982-12.542 8.858-15.359l5.96-3.441.433.732-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.983 12.542-8.859 15.359z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m311.678 529.745-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.541 8.858-15.359l5.96-3.44.433.732-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.6v6.881c0 5.634-3.983 12.542-8.859 15.359z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m300.598 523.38-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.88c0 5.635-3.982 12.542-8.858 15.359z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m289.518 516.987-.433-.732 28.472-16.442c4.659-2.682 8.424-9.237 8.424-14.601v-6.853c0-5.634 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.853c0 5.635-3.982 12.542-8.858 15.359z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m278.465 510.594-.434-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.635 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.959 3.44c-4.66 2.682-8.425 9.237-8.425 14.601v6.88c0 5.634-3.983 12.542-8.859 15.359z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m267.384 504.228-.434-.731 28.472-16.443c4.659-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.982-12.541 8.858-15.359l5.96-3.44.433.732-5.959 3.44c-4.66 2.681-8.425 9.237-8.425 14.6v6.881c0 5.634-3.983 12.541-8.859 15.359z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m210.362 523.731-.217-.108-121.092-69.535.433-.759 120.903 69.4 45.511-25.652 28.471-16.443c4.66-2.681 8.425-9.237 8.425-14.6v-6.854c0-5.634 3.983-12.541 8.859-15.358l5.96-3.441.433.732-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.6v6.854c0 5.634-3.982 12.541-8.858 15.359l-28.472 16.442z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m245.226 491.47-.433-.732 28.472-16.442c4.659-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.982-12.542 8.858-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.238-8.425 14.601v6.88c0 5.635-3.982 12.542-8.858 15.359z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m234.146 485.077-.433-.732 28.471-16.442c4.66-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.635 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.88c0 5.634-3.982 12.542-8.858 15.359z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m223.068 478.712-.433-.732 28.471-16.442c4.66-2.682 8.425-9.237 8.425-14.601v-6.853c0-5.634 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.982 12.542-8.858 15.359z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m212.017 472.318-.433-.731 28.472-16.443c4.659-2.681 8.424-9.237 8.424-14.6v-6.881c0-5.634 3.983-12.541 8.859-15.359l5.96-3.44.433.732-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.6v6.881c0 5.634-3.982 12.542-8.858 15.359z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m200.935 465.925-.433-.731 28.471-16.443c4.66-2.681 8.425-9.237 8.425-14.6v-6.88c0-5.635 3.983-12.542 8.859-15.359l5.96-3.441.433.732-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.6v6.881c0 5.634-3.982 12.542-8.858 15.359z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m189.858 459.56-.433-.731 28.471-16.443c4.66-2.681 8.425-9.237 8.425-14.6v-6.854c0-5.634 3.983-12.541 8.859-15.358l5.96-3.441.433.732-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.6v6.854c0 5.634-3.982 12.541-8.858 15.359z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m178.778 453.167-.433-.732 28.471-16.442c4.66-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.982-12.542 8.859-15.359l5.959-3.44.434.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.88c0 5.635-3.982 12.542-8.858 15.359z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m167.692 446.802-.433-.732 28.471-16.442c4.66-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.238-8.425 14.601V415c0 5.635-3.982 12.542-8.858 15.359z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m156.64 440.408-.434-.731 28.472-16.443c4.659-2.681 8.425-9.237 8.425-14.6v-6.853c0-5.635 3.982-12.542 8.858-15.359l5.96-3.441.433.732-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.853c0 5.634-3.982 12.542-8.858 15.359z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m145.561 434.043-.433-.732 28.471-16.442c4.66-2.682 8.425-9.237 8.425-14.601v-6.88c0-5.634 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.44c-4.659 2.682-8.425 9.237-8.425 14.601v6.88c0 5.635-3.982 12.542-8.858 15.359z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m134.482 427.65-.433-.731 28.471-16.443c4.66-2.682 8.425-9.237 8.425-14.6v-6.881c0-5.634 3.983-12.542 8.859-15.359l5.96-3.44.433.731-5.96 3.441c-4.659 2.681-8.425 9.237-8.425 14.6v6.881c0 5.634-3.982 12.541-8.858 15.358z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m170.789 274.184-40.798-23.567v47.134l40.798 23.566 40.824-23.566v-47.134z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m170.789 321.317-40.798-23.566v-47.134l40.798 23.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__i)",
    d: "m170.789 321.317-40.798-23.566v-47.134l40.798 23.567z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m211.614 297.75-40.825 23.567v-47.133l40.825-23.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__j)",
    d: "m211.614 297.75-40.825 23.567v-47.133l40.825-23.567z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m170.789 274.184-40.798-23.567 40.798-23.566 40.824 23.566z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m170.789 274.184-40.798-23.567v2.059l40.798 23.539 40.824-23.539v-2.059z",
    opacity: 0.1
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#08061A",
    d: "m170.789 245.606-40.798-23.567 40.798-23.539 40.824 23.539z",
    opacity: 0.4
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m170.789 162.798-40.798-23.567v47.134l40.798 23.566 40.824-23.566v-47.134z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__k)",
    d: "m170.789 209.931-40.798-23.566v-47.134l40.798 23.567z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__l)",
    d: "m170.789 209.931-40.798-23.566v-47.134l40.798 23.567z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m211.618 186.365-40.825 23.566v-47.133l40.825-23.567z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__m)",
    d: "m211.618 186.365-40.825 23.566v-47.133l40.825-23.567z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__n)",
    d: "m170.789 162.798-40.798-23.566 40.798-23.567 40.824 23.567z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m170.789 162.798-40.798-23.567v2.032l40.798 23.567 40.824-23.567v-2.032z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m134.438 59.561-46.508-7.54 16.742 44.06 46.509 7.54 29.791-36.53-16.743-44.06z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__o)",
    d: "m151.181 103.621-46.509-7.54-16.742-44.06 46.508 7.54z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__p)",
    d: "m151.181 103.621-46.509-7.54-16.742-44.06 46.508 7.54z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m180.977 67.09-29.791 36.529-16.742-44.06 29.791-36.53 16.742 44.06z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__q)",
    d: "m180.977 67.09-29.791 36.529-16.742-44.06 29.791-36.53 16.742 44.06z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__r)",
    d: "m134.439 59.561-46.508-7.54 29.766-36.52 46.534 7.53z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m134.438 59.561-46.508-7.54.731 1.925 46.499 7.514 29.801-36.504-.732-1.924-29.791 36.53z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m718.865 335.036-40.825-23.539v47.106l40.825 23.567 40.824-23.567v-47.106z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m718.865 382.17-40.825-23.567v-47.106l40.825 23.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__s)",
    d: "m718.865 382.17-40.825-23.567v-47.106l40.825 23.539z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m759.692 358.603-40.825 23.566v-47.133l40.825-23.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__t)",
    d: "m759.692 358.603-40.825 23.566v-47.133l40.825-23.54z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m718.865 335.036-40.825-23.539 40.825-23.567 40.824 23.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__u)",
    d: "m718.865 335.036-40.825-23.539 40.825-23.567 40.824 23.567z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m718.865 335.036-40.825-23.539v2.031l40.825 23.567 40.824-23.567v-2.031z",
    opacity: 0.1
  }))), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m719.947 317.537-.217-.136-59.76-34.483.65-.379 59.327-34.24.217.136 59.76 34.483-.65.379zm-58.271-34.619 58.244 33.643 58.243-33.643-58.243-33.616z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#08061A",
    d: "m718.863 306.485-40.825-23.567 40.825-23.566 40.824 23.566z",
    opacity: 0.4
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m718.863 223.649-40.825-23.566v47.133l40.825 23.567 40.824-23.567v-47.133z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m718.863 270.783-40.825-23.567v-47.133l40.825 23.566z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__v)",
    d: "m718.863 270.783-40.825-23.567v-47.133l40.825 23.566z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m759.687 247.216-40.825 23.567v-47.134l40.825-23.566z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__w)",
    d: "m759.687 247.216-40.825 23.567v-47.134l40.825-23.566z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__x)",
    d: "m718.863 223.649-40.825-23.566 40.825-23.567 40.824 23.567z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m718.863 223.649-40.825-23.566v2.058l40.825 23.567 40.824-23.567v-2.058z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m59.977 471.1-.216-.136L0 436.481l.65-.379 59.327-34.24.217.136 59.76 34.51-.65.379zm-58.27-34.619 58.243 33.643 58.244-33.643-58.244-33.644z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m59.98 489.357-40.825-23.566v47.133l40.825 23.567 40.797-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m59.98 536.491-40.825-23.567v-47.133l40.825 23.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__y)",
    d: "m59.98 536.491-40.825-23.567v-47.133l40.825 23.566z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m100.78 512.924-40.798 23.567v-47.134l40.798-23.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__z)",
    d: "m100.78 512.924-40.798 23.567v-47.134l40.798-23.566z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m59.98 489.358-40.825-23.567 40.825-23.567 40.797 23.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__A)",
    d: "m59.98 489.358-40.825-23.567 40.825-23.567 40.797 23.567z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m59.98 489.357-40.825-23.566v2.058l40.825 23.54 40.797-23.54v-2.058z",
    opacity: 0.1
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#08061A",
    d: "M59.976 460.779 19.15 437.213l40.825-23.54 40.797 23.54-40.797 23.566z",
    opacity: 0.4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M59.976 377.97 19.15 354.404v47.133l40.825 23.567 40.797-23.567v-47.133z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__B)",
    d: "M59.976 425.104 19.15 401.537v-47.133l40.825 23.566z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__C)",
    d: "M59.976 425.104 19.15 401.537v-47.133l40.825 23.566z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m100.776 401.537-40.797 23.567V377.97l40.797-23.566z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__D)",
    d: "m100.776 401.537-40.797 23.567V377.97l40.797-23.566z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__E)",
    d: "M59.976 377.971 19.15 354.404l40.825-23.567 40.797 23.567-40.797 23.567z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.976 377.97 19.15 354.404v2.031l40.825 23.567 40.797-23.567v-2.031z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.414 713.971-40.824-23.566v47.133l40.824 23.567 40.798-23.567v-47.133z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.414 761.105-40.824-23.567v-47.133l40.824 23.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__F)",
    d: "m396.414 761.105-40.824-23.567v-47.133l40.824 23.566z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m437.214 737.538-40.798 23.567v-47.134l40.798-23.566z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__G)",
    d: "m437.214 737.538-40.798 23.567v-47.134l40.798-23.566z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.414 713.972-40.824-23.567 40.824-23.567 40.798 23.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__H)",
    d: "m396.414 713.972-40.824-23.567 40.824-23.567 40.798 23.567z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m396.414 713.971-40.824-23.566v2.058l40.824 23.567 40.798-23.567v-2.058z",
    opacity: 0.1
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#08061A",
    d: "m396.414 685.394-40.824-23.567 40.824-23.539 40.798 23.566z",
    opacity: 0.4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m396.414 602.585-40.824-23.567v47.133l40.824 23.567 40.798-23.567v-47.133z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__I)",
    d: "m396.414 649.718-40.824-23.567v-47.133l40.824 23.567z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__J)",
    d: "m396.414 649.718-40.824-23.567v-47.133l40.824 23.567z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m437.216 626.151-40.797 23.567v-47.133l40.797-23.567z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__K)",
    d: "m437.216 626.151-40.797 23.567v-47.133l40.797-23.567z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__L)",
    d: "m396.414 602.585-40.824-23.567 40.824-23.566 40.798 23.566z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m396.414 602.585-40.824-23.567v2.032l40.824 23.566 40.798-23.566v-2.032z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 257.671-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 304.804-40.825-23.566v-47.134l40.825 23.567z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 281.237 400.4 304.804v-47.133l40.825-23.567z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 257.671-40.825-23.566 40.825-23.54 40.824 23.54z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 257.672-39.037-22.538-1.788 1.03 40.825 23.566 40.824-23.566-1.76-1.03z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 287.929-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 335.063-40.798-23.567v-47.133l40.798 23.566z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 311.496-40.825 23.567v-47.134l40.825-23.566z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 287.929-40.798-23.566 40.798-23.567 40.824 23.567z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 287.93-39.037-22.538-1.761 1.03 40.798 23.566 40.824-23.566-1.761-1.03z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 318.186-40.825-23.567v47.133l40.825 23.567 40.797-23.567v-47.133z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 365.319-40.825-23.567v-47.133l40.825 23.567z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__M)",
    d: "m506.45 365.319-40.825-23.567v-47.133l40.825 23.567z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m547.25 341.753-40.798 23.566v-47.133l40.798-23.567z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__N)",
    d: "m547.25 341.753-40.798 23.566v-47.133l40.798-23.567z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__O)",
    d: "m506.45 318.186-40.825-23.567 40.797-23.566 40.825 23.566z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m506.45 318.186-39.064-22.537-1.761 1.002 40.825 23.566 40.797-23.566v-2.032z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 289.988-40.824-23.567v47.106l40.824 23.567 40.825-23.567v-47.106z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 337.094-40.824-23.567v-47.106l40.824 23.567z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 313.527-40.824 23.567v-47.106l40.824-23.567z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 289.988-40.824-23.567 40.824-23.566 40.825 23.566z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 289.989-39.036-22.565-1.788 1.029 40.824 23.567 40.825-23.567-1.788-1.029z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 320.218-40.825-23.567v47.133l40.825 23.567 40.824-23.567v-47.133z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 367.351-40.825-23.567v-47.133l40.825 23.567z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 343.784 400.4 367.351v-47.133l40.825-23.567z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 320.218-40.825-23.567 40.825-23.566 40.824 23.566z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 320.219-39.037-22.538-1.788 1.03 40.825 23.566 40.824-23.566-1.76-1.03z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 350.475-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 397.609-40.798-23.567v-47.133l40.798 23.566z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__P)",
    d: "m453.411 397.609-40.798-23.567v-47.133l40.798 23.566z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 374.042-40.825 23.567v-47.134l40.825-23.566z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__Q)",
    d: "m494.236 374.042-40.825 23.567v-47.134l40.825-23.566z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__R)",
    d: "m453.411 350.476-40.798-23.567 40.798-23.567 40.824 23.567z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 350.475-39.037-22.537-1.761 1.029 40.798 23.54 40.824-23.54v-2.058z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M294.365 322.277 253.54 298.71v47.134l40.825 23.566 40.824-23.566V298.71z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__S)",
    d: "m294.365 369.41-40.825-23.566V298.71l40.825 23.567z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__T)",
    d: "m294.365 369.41-40.825-23.566V298.71l40.825 23.567z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m335.192 345.843-40.825 23.567v-47.133l40.825-23.567z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__U)",
    d: "m335.192 345.843-40.825 23.567v-47.133l40.825-23.567z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__V)",
    d: "M294.365 322.277 253.54 298.71l40.825-23.566 40.797 23.566z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M294.365 322.277 253.54 298.71v2.032l40.825 23.567 40.797-23.567-1.761-1.002z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 352.507-40.824-23.54v47.107l40.824 23.566 40.825-23.566v-47.107z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__W)",
    d: "m347.383 399.64-40.824-23.566v-47.107l40.824 23.54z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__X)",
    d: "m347.383 399.64-40.824-23.566v-47.107l40.824 23.54z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 376.073-40.824 23.567v-47.133l40.824-23.54z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__Y)",
    d: "m388.21 376.073-40.824 23.567v-47.133l40.824-23.54z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__Z)",
    d: "m347.383 352.507-40.824-23.539 40.824-23.567 40.825 23.567z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 352.507-40.824-23.54v2.032l40.824 23.567 40.825-23.567-1.788-1.029z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 382.765-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aa)",
    d: "m400.398 429.898-40.825-23.566v-47.134l40.825 23.567z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ab)",
    d: "m400.398 429.898-40.825-23.566v-47.134l40.825 23.567z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 406.332 400.4 429.898v-47.133l40.825-23.567z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ac)",
    d: "M441.225 406.332 400.4 429.898v-47.133l40.825-23.567z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ad)",
    d: "m400.398 382.765-40.825-23.566 40.825-23.567 40.824 23.567z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 382.765-40.825-23.567v2.059l40.825 23.567 40.824-23.567v-2.059z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 195.125-40.825-23.539v47.106l40.825 23.567 40.824-23.567v-47.106z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 242.259-40.825-23.567v-47.106l40.825 23.539z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ae)",
    d: "m400.398 242.259-40.825-23.567v-47.106l40.825 23.539z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 218.692 400.4 242.258v-47.133l40.825-23.54z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__af)",
    d: "M441.225 218.692 400.4 242.258v-47.133l40.825-23.54z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ag)",
    d: "m400.398 195.126-40.825-23.54 40.825-23.567 40.824 23.567z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 195.126-39.037-22.537-1.788 1.029 40.825 23.567 40.824-23.567-1.76-1.029z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#878BA3",
    d: "m400.398 375.099-27.848-16.091 27.848-16.063 27.849 16.063zm-53.018-30.258-27.849-16.063 27.849-16.09 27.848 16.09zm106.031-2.031-27.849-16.09 27.849-16.064 27.848 16.064zm53.123-31.937-27.848-16.063 27.848-16.091 27.849 16.091zm-212.169 3.711-27.848-16.063 27.848-16.063 27.849 16.063z",
    opacity: 0.7
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 225.383-40.798-23.567v47.134l40.798 23.566 40.824-23.566v-47.134z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 272.516-40.798-23.566v-47.134l40.798 23.567z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ah)",
    d: "m453.411 272.516-40.798-23.566v-47.134l40.798 23.567z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 248.95-40.825 23.566v-47.133l40.825-23.567z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ai)",
    d: "m494.236 248.95-40.825 23.566v-47.133l40.825-23.567z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aj)",
    d: "m453.411 225.383-40.798-23.567 40.798-23.566 40.824 23.566z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 225.384-39.037-22.538-1.761 1.03 40.798 23.566 40.824-23.566-1.761-1.03z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 255.64-40.825-23.567v47.134l40.825 23.566 40.797-23.566v-47.134z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 302.773-40.825-23.566v-47.134l40.825 23.567z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ak)",
    d: "m506.45 302.773-40.825-23.566v-47.134l40.825 23.567z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m547.25 279.207-40.798 23.566V255.64l40.798-23.567z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__al)",
    d: "m547.25 279.207-40.798 23.566V255.64l40.798-23.567z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__am)",
    d: "m506.45 255.64-40.825-23.567 40.797-23.566 40.825 23.566z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m506.45 255.64-39.064-22.537-1.761 1.002 40.825 23.567 40.797-23.567v-2.032z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 227.441-40.824-23.566v47.133l40.824 23.539 40.825-23.539v-47.133z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 274.547-40.824-23.539v-47.133l40.824 23.566z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__an)",
    d: "m347.383 274.547-40.824-23.539v-47.133l40.824 23.566z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 251.008-40.824 23.539v-47.106l40.824-23.566z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ao)",
    d: "m388.21 251.008-40.824 23.539v-47.106l40.824-23.566z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ap)",
    d: "m347.383 227.441-40.824-23.566 40.824-23.567 40.825 23.567z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 227.442-39.036-22.565-1.788 1.03 40.824 23.566 40.825-23.566-1.788-1.03z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 257.671-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 304.804-40.825-23.566v-47.134l40.825 23.567z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aq)",
    d: "m400.398 304.804-40.825-23.566v-47.134l40.825 23.567z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 281.237 400.4 304.804v-47.133l40.825-23.567z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ar)",
    d: "M441.225 281.237 400.4 304.804v-47.133l40.825-23.567z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__as)",
    d: "m400.398 257.671-40.825-23.566 40.825-23.54 40.824 23.54z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 257.672-39.037-22.538-1.788 1.03 40.825 23.566 40.824-23.566-1.76-1.03z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 287.929-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 335.063-40.798-23.567v-47.133l40.798 23.566z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__at)",
    d: "m453.411 335.063-40.798-23.567v-47.133l40.798 23.566z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 311.496-40.825 23.567v-47.134l40.825-23.566z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__au)",
    d: "m494.236 311.496-40.825 23.567v-47.134l40.825-23.566z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__av)",
    d: "m453.411 287.929-40.798-23.566 40.798-23.567 40.824 23.567z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 287.929-39.037-22.537-1.761 1.029 40.798 23.567 40.824-23.567v-2.058z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 259.73-40.825-23.567v47.134l40.825 23.566 40.824-23.566v-47.134z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aw)",
    d: "m294.365 306.863-40.825-23.566v-47.134l40.825 23.567z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ax)",
    d: "m294.365 306.863-40.825-23.566v-47.134l40.825 23.567z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m335.192 283.296-40.825 23.567V259.73l40.825-23.567z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ay)",
    d: "m335.192 283.296-40.825 23.567V259.73l40.825-23.567z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__az)",
    d: "m294.365 259.73-40.825-23.566 40.825-23.567 40.797 23.567z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m294.365 259.731-39.064-22.538-1.761 1.003 40.825 23.566 40.797-23.566-1.761-1.003z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 289.988-40.824-23.567v47.106l40.824 23.567 40.825-23.567v-47.106z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aA)",
    d: "m347.383 337.094-40.824-23.567v-47.106l40.824 23.567z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aB)",
    d: "m347.383 337.094-40.824-23.567v-47.106l40.824 23.567z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 313.527-40.824 23.567v-47.106l40.824-23.567z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aC)",
    d: "m388.21 313.527-40.824 23.567v-47.106l40.824-23.567z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aD)",
    d: "m347.383 289.988-40.824-23.567 40.824-23.566 40.825 23.566z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 289.988-40.824-23.567v2.032l40.824 23.566 40.825-23.566-1.788-1.03z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 320.218-40.825-23.567v47.133l40.825 23.567 40.824-23.567v-47.133z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aE)",
    d: "m400.398 367.351-40.825-23.567v-47.133l40.825 23.567z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aF)",
    d: "M441.225 343.784 400.4 367.351v-47.133l40.825-23.567z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aG)",
    d: "m400.398 320.218-40.825-23.567 40.825-23.566 40.824 23.566z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 320.218-40.825-23.567v2.059l40.825 23.566 40.824-23.566v-2.059z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#878BA3",
    d: "m506.534 248.597-27.848-16.063 27.848-16.063 27.849 16.063zm-212.169 3.738-27.848-16.09 27.848-16.063 27.849 16.063z",
    opacity: 0.7
  }))), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 132.605-40.825-23.566v47.106l40.825 23.567 40.824-23.567v-47.106z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 179.712-40.825-23.567v-47.106l40.825 23.566z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aH)",
    d: "m400.398 179.712-40.825-23.567v-47.106l40.825 23.566z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "M441.225 156.145 400.4 179.711v-47.106l40.825-23.567z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aI)",
    d: "M441.225 156.145 400.4 179.711v-47.106l40.825-23.567z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m400.398 132.606-40.825-23.567 40.825-23.567 40.824 23.567z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aJ)",
    d: "m400.398 132.606-40.825-23.567 40.825-23.567 40.824 23.567z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m400.398 132.605-40.825-23.566v2.031l40.825 23.567 40.824-23.567v-2.031z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 162.835-40.798-23.566v47.133l40.798 23.567 40.824-23.567v-47.133z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 209.969-40.798-23.567v-47.133l40.798 23.566z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aK)",
    d: "m453.411 209.969-40.798-23.567v-47.133l40.798 23.566z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m494.236 186.402-40.825 23.567v-47.134l40.825-23.566z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aL)",
    d: "m494.236 186.402-40.825 23.567v-47.134l40.825-23.566z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m453.411 162.836-40.798-23.567 40.798-23.567 40.824 23.567z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aM)",
    d: "m453.411 162.836-40.798-23.567 40.798-23.567 40.824 23.567z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m453.411 162.835-40.798-23.566v2.058l40.798 23.567 40.824-23.567v-2.058z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 193.093-40.825-23.566v47.133l40.825 23.567 40.797-23.567v-47.133z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 240.227-40.825-23.567v-47.133l40.825 23.566z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aN)",
    d: "m506.45 240.227-40.825-23.567v-47.133l40.825 23.566z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m547.25 216.66-40.798 23.566v-47.133l40.798-23.567z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aO)",
    d: "m547.25 216.66-40.798 23.566v-47.133l40.798-23.567z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m506.45 193.094-40.825-23.567 40.797-23.567 40.825 23.567z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aP)",
    d: "m506.45 193.094-40.825-23.567 40.797-23.567 40.825 23.567z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m506.45 193.093-40.825-23.566v2.058l40.825 23.54 40.797-23.54v-2.058z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 164.894-40.824-23.566v47.133l40.824 23.567 40.825-23.567v-47.133z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aQ)",
    d: "m347.383 212.028-40.824-23.567v-47.133l40.824 23.566z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aR)",
    d: "m347.383 212.028-40.824-23.567v-47.133l40.824 23.566z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m388.21 188.461-40.824 23.567v-47.134l40.824-23.566z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aS)",
    d: "m388.21 188.461-40.824 23.567v-47.134l40.824-23.566z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m347.383 164.895-40.824-23.567 40.824-23.567 40.825 23.567z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aT)",
    d: "m347.383 164.895-40.824-23.567 40.824-23.567 40.825 23.567z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m347.383 164.894-40.824-23.566v2.031l40.824 23.567 40.825-23.567v-2.031z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 197.184-40.825-23.566v47.133l40.825 23.567 40.824-23.567v-47.133z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aU)",
    d: "m294.365 244.318-40.825-23.567v-47.133l40.825 23.566z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aV)",
    d: "m294.365 244.318-40.825-23.567v-47.133l40.825 23.566z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m335.192 220.751-40.825 23.567v-47.134l40.825-23.566z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aW)",
    d: "m335.192 220.751-40.825 23.567v-47.134l40.825-23.566z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m294.365 197.185-40.825-23.567 40.825-23.567 40.797 23.567z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aX)",
    d: "m294.365 197.185-40.825-23.567 40.825-23.567 40.797 23.567z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m294.365 197.184-40.825-23.566v2.031l40.825 23.567 40.797-23.567.027-2.031z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aY)",
    d: "M568.683 343.135V37.905h-336.81l.244 305.23L400.4 440.273z",
    opacity: 0.5
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M157.53 495.804a5.503 5.503 0 0 0 5.5 5.499 5.503 5.503 0 0 0 5.499-5.499 5.503 5.503 0 0 0-5.499-5.499 5.503 5.503 0 0 0-5.5 5.499",
    opacity: 0.4
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M163.032 498.187a2.384 2.384 0 1 0 0-4.767 2.384 2.384 0 0 0 0 4.767"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M644.8 244.67c0 3.034 2.465 5.5 5.499 5.5a5.504 5.504 0 0 0 5.499-5.5 5.503 5.503 0 0 0-5.499-5.499c-3.034-.027-5.499 2.438-5.499 5.499",
    opacity: 0.4
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M647.918 244.67a2.39 2.39 0 0 0 2.384 2.384 2.37 2.37 0 0 0 2.384-2.384 2.39 2.39 0 0 0-2.384-2.384c-1.328-.027-2.384 1.057-2.384 2.384"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m753.354 598.538 35.325 31.206 9.373-46.186-35.298-31.205-44.698 14.98-9.373 46.185z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m762.756 552.353 35.298 31.205-9.373 46.186-35.326-31.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__aZ)",
    d: "m762.756 552.353 35.298 31.205-9.373 46.186-35.326-31.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__ba)",
    d: "m762.756 552.353 35.298 31.205-9.373 46.186-35.326-31.206z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m718.056 567.333 44.698-14.98-9.4 46.185-44.671 14.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__bb)",
    d: "m718.056 567.333 44.698-14.98-9.4 46.185-44.671 14.98z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m753.354 598.538 35.325 31.206-44.698 14.98-35.298-31.206z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m753.354 598.538 35.325 31.205.407-2.004-35.299-31.206-44.698 14.98-.406 2.005z",
    opacity: 0.1
  }))), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#08061A",
    d: "m760.587 580.579-40.798-23.567 40.798-23.567 40.824 23.567z",
    opacity: 0.4
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M760.587 621.508c-26.901 0-53.801-5.905-74.281-17.742-19.911-11.513-30.91-26.818-30.91-43.125s10.972-31.639 30.91-43.124c40.96-23.648 107.601-23.648 148.589 0 19.938 11.512 30.909 26.817 30.909 43.124s-10.971 31.639-30.882 43.125c-20.507 11.837-47.408 17.742-74.335 17.742m0-120.894c-26.738 0-53.503 5.878-73.847 17.634-19.641 11.35-30.477 26.411-30.477 42.393s10.809 31.043 30.477 42.393c40.716 23.513 107.005 23.513 147.721 0 19.64-11.35 30.476-26.411 30.476-42.393 0-16.009-10.809-31.043-30.476-42.393-20.371-11.756-47.109-17.634-73.874-17.634",
    opacity: 0.4
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M760.587 637.815c-34.134 0-68.267-7.503-94.273-22.51-25.248-14.573-39.172-33.995-39.172-54.664 0-20.668 13.924-40.09 39.172-54.663 51.985-30.014 136.56-30.014 188.519 0 25.275 14.573 39.172 33.995 39.172 54.663 0 20.669-13.897 40.091-39.172 54.664l-.217-.379.217.379c-25.952 15.007-60.086 22.51-94.246 22.51m0-153.508c-33.971 0-67.969 7.476-93.84 22.402-24.977 14.438-38.739 33.562-38.739 53.932 0 20.344 13.762 39.495 38.739 53.933 51.742 29.878 135.938 29.878 187.679 0 24.977-14.438 38.739-33.562 38.739-53.933 0-20.37-13.762-39.494-38.739-53.932-25.871-14.926-59.841-22.402-93.839-22.402",
    opacity: 0.2
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M760.615 608.668c-21.212 0-42.396-4.659-58.542-13.977-15.712-9.075-24.381-21.156-24.381-34.05s8.669-24.975 24.381-34.05c32.292-18.636 84.819-18.636 117.11 0 15.712 9.075 24.381 21.183 24.381 34.05s-8.669 24.975-24.381 34.05c-16.172 9.318-37.384 13.977-58.568 13.977m-.027-95.214c-21.049 0-42.098 4.632-58.108 13.869-15.442 8.912-23.948 20.749-23.948 33.318s8.506 24.38 23.948 33.319c32.047 18.501 84.195 18.501 116.243 0l.217.379-.217-.379c15.441-8.912 23.947-20.75 23.947-33.292 0-12.569-8.506-24.406-23.947-33.318-16.037-9.264-37.086-13.896-58.135-13.896"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m755.9 515.567-4.686-46.917-38.278 27.522 4.686 46.889 42.938 19.395 38.278-27.494z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__bc)",
    d: "m717.622 543.061-4.686-46.889 38.278-27.522 4.686 46.917z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#2FD3C7",
    d: "m760.562 562.456-42.938-19.395 38.278-27.494 42.938 19.395z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__bd)",
    d: "m760.562 562.456-42.938-19.395 38.278-27.494 42.938 19.395z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m755.901 515.567-4.686-46.917 42.965 19.422 4.659 46.89z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#hero_svg__be)",
    d: "m755.901 515.567-4.686-46.917 42.965 19.422 4.659 46.89z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m755.902 515.567-4.687-46.917-1.653 1.192 4.687 46.917 42.938 19.395 1.652-1.192z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#03002D",
    d: "M736.477 551.567h39.226l-15.143 10.89z",
    opacity: 0.4
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M826.575 584.507a5.503 5.503 0 0 0 5.499 5.499c3.035 0 5.5-2.465 5.5-5.499a5.503 5.503 0 0 0-5.5-5.499c-3.034-.028-5.499 2.438-5.499 5.499",
    opacity: 0.4
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M832.077 586.891a2.384 2.384 0 1 0 0-4.767 2.384 2.384 0 0 0 0 4.767"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M727.104 612.623a8.588 8.588 0 1 0 0-17.176 8.588 8.588 0 0 0 0 17.176",
    opacity: 0.4
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M723.395 604.036a3.746 3.746 0 0 0 3.738 3.739 3.746 3.746 0 0 0 3.738-3.739 3.745 3.745 0 0 0-3.738-3.738 3.745 3.745 0 0 0-3.738 3.738"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M692.67 529.057a5.816 5.816 0 0 0 5.824 5.824 5.816 5.816 0 0 0 5.825-5.824 5.816 5.816 0 0 0-5.825-5.825 5.816 5.816 0 0 0-5.824 5.825",
    opacity: 0.4
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M695.979 529.057a2.514 2.514 0 0 0 2.519 2.519 2.53 2.53 0 0 0 2.519-2.519 2.514 2.514 0 0 0-2.519-2.52 2.514 2.514 0 0 0-2.519 2.52"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M586.119 212.896a5.503 5.503 0 0 0 5.499 5.499c3.034 0 5.5-2.465 5.5-5.499s-2.466-5.5-5.5-5.5a5.504 5.504 0 0 0-5.499 5.5",
    opacity: 0.4
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M589.237 212.895a2.39 2.39 0 0 0 2.384 2.384 2.387 2.387 0 0 0 2.384-2.384 2.387 2.387 0 0 0-2.384-2.384 2.39 2.39 0 0 0-2.384 2.384"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M95.282 460.78a5.503 5.503 0 0 0 5.499 5.499c3.035 0 5.5-2.465 5.5-5.499 0-3.035-2.465-5.5-5.5-5.5a5.503 5.503 0 0 0-5.499 5.5",
    opacity: 0.4
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M98.4 460.779a2.39 2.39 0 0 0 2.384 2.384 2.387 2.387 0 0 0 2.384-2.384 2.37 2.37 0 0 0-2.384-2.384 2.405 2.405 0 0 0-2.384 2.384"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__a",
    x1: 73.411,
    x2: 634.163,
    y1: 496.816,
    y2: 496.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#5E67DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#727AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692,
    stopColor: "#9297EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__b",
    x1: 73.411,
    x2: 634.163,
    y1: 443.395,
    y2: 443.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767BA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__c",
    x1: 232.101,
    x2: 568.684,
    y1: 367.624,
    y2: 367.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__d",
    x1: 400.391,
    x2: 568.682,
    y1: 306.8,
    y2: 306.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#43E3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#4E9CDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#5472D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5761D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__e",
    x1: 232.105,
    x2: 400.397,
    y1: 306.788,
    y2: 306.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__f",
    x1: 232.101,
    x2: 568.684,
    y1: 343.109,
    y2: 343.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__g",
    x1: 400.387,
    x2: 568.678,
    y1: 403.954,
    y2: 403.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__h",
    x1: 232.105,
    x2: 400.397,
    y1: 403.954,
    y2: 403.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__i",
    x1: 167.666,
    x2: 129.603,
    y1: 321.64,
    y2: 250.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__j",
    x1: 171.215,
    x2: 211.802,
    y1: 302.868,
    y2: 268.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__k",
    x1: 150.39,
    x2: 150.39,
    y1: 139.231,
    y2: 209.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__l",
    x1: 167.666,
    x2: 129.603,
    y1: 210.254,
    y2: 139.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__m",
    x1: 171.219,
    x2: 211.806,
    y1: 191.483,
    y2: 157.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__n",
    x1: 170.802,
    x2: 170.802,
    y1: 115.665,
    y2: 162.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__o",
    x1: 106.998,
    x2: 132.109,
    y1: 44.776,
    y2: 110.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__p",
    x1: 148.376,
    x2: 87.573,
    y1: 105.032,
    y2: 52.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__q",
    x1: 145.031,
    x2: 170.897,
    y1: 86.222,
    y2: 40.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__r",
    x1: 117.709,
    x2: 134.45,
    y1: 15.497,
    y2: 59.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__s",
    x1: 715.74,
    x2: 677.714,
    y1: 382.492,
    y2: 311.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__t",
    x1: 719.293,
    x2: 759.868,
    y1: 363.727,
    y2: 329.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__u",
    x1: 718.865,
    x2: 718.865,
    y1: 287.93,
    y2: 335.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__v",
    x1: 715.738,
    x2: 677.689,
    y1: 271.105,
    y2: 200.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__w",
    x1: 719.288,
    x2: 759.876,
    y1: 252.334,
    y2: 218.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__x",
    x1: 718.863,
    x2: 718.863,
    y1: 176.516,
    y2: 223.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__y",
    x1: 56.855,
    x2: 18.806,
    y1: 536.813,
    y2: 465.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__z",
    x1: 60.408,
    x2: 100.991,
    y1: 518.042,
    y2: 484.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__A",
    x1: 59.966,
    x2: 59.966,
    y1: 442.224,
    y2: 489.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__B",
    x1: 39.564,
    x2: 39.564,
    y1: 354.404,
    y2: 425.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__C",
    x1: 56.851,
    x2: 18.803,
    y1: 425.426,
    y2: 354.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__D",
    x1: 60.404,
    x2: 100.987,
    y1: 406.655,
    y2: 372.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__E",
    x1: 59.962,
    x2: 59.962,
    y1: 330.837,
    y2: 377.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__F",
    x1: 393.29,
    x2: 355.241,
    y1: 761.427,
    y2: 690.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__G",
    x1: 396.842,
    x2: 437.424,
    y1: 742.656,
    y2: 708.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__H",
    x1: 396.401,
    x2: 396.401,
    y1: 666.838,
    y2: 713.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__I",
    x1: 376.002,
    x2: 376.002,
    y1: 579.018,
    y2: 649.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__J",
    x1: 393.29,
    x2: 355.241,
    y1: 650.04,
    y2: 579.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__K",
    x1: 396.845,
    x2: 437.427,
    y1: 631.269,
    y2: 597.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__L",
    x1: 396.401,
    x2: 396.401,
    y1: 555.452,
    y2: 602.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__M",
    x1: 503.325,
    x2: 465.276,
    y1: 365.642,
    y2: 294.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__N",
    x1: 506.878,
    x2: 547.461,
    y1: 346.87,
    y2: 312.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__O",
    x1: 506.436,
    x2: 506.436,
    y1: 271.053,
    y2: 318.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__P",
    x1: 450.288,
    x2: 412.226,
    y1: 397.931,
    y2: 326.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__Q",
    x1: 453.837,
    x2: 494.425,
    y1: 379.16,
    y2: 345.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__R",
    x1: 453.424,
    x2: 453.424,
    y1: 303.342,
    y2: 350.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__S",
    x1: 273.952,
    x2: 273.952,
    y1: 298.71,
    y2: 369.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__T",
    x1: 291.24,
    x2: 253.191,
    y1: 369.733,
    y2: 298.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__U",
    x1: 294.793,
    x2: 335.381,
    y1: 350.961,
    y2: 316.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__V",
    x1: 294.351,
    x2: 294.351,
    y1: 275.144,
    y2: 322.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__W",
    x1: 326.971,
    x2: 326.971,
    y1: 328.967,
    y2: 399.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__X",
    x1: 344.259,
    x2: 306.233,
    y1: 399.963,
    y2: 328.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__Y",
    x1: 347.812,
    x2: 388.386,
    y1: 381.198,
    y2: 347.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__Z",
    x1: 347.383,
    x2: 347.383,
    y1: 305.401,
    y2: 352.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aa",
    x1: 379.986,
    x2: 379.986,
    y1: 359.198,
    y2: 429.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ab",
    x1: 397.273,
    x2: 359.225,
    y1: 430.221,
    y2: 359.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ac",
    x1: 400.827,
    x2: 441.414,
    y1: 411.449,
    y2: 377.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ad",
    x1: 400.398,
    x2: 400.398,
    y1: 335.632,
    y2: 382.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ae",
    x1: 397.273,
    x2: 359.247,
    y1: 242.581,
    y2: 171.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__af",
    x1: 400.827,
    x2: 441.401,
    y1: 223.817,
    y2: 189.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ag",
    x1: 400.398,
    x2: 400.398,
    y1: 148.019,
    y2: 195.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ah",
    x1: 450.288,
    x2: 412.226,
    y1: 272.839,
    y2: 201.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ai",
    x1: 453.837,
    x2: 494.425,
    y1: 254.067,
    y2: 220.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aj",
    x1: 453.424,
    x2: 453.424,
    y1: 178.25,
    y2: 225.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ak",
    x1: 503.325,
    x2: 465.276,
    y1: 303.096,
    y2: 232.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__al",
    x1: 506.878,
    x2: 547.461,
    y1: 284.324,
    y2: 250.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__am",
    x1: 506.436,
    x2: 506.436,
    y1: 208.507,
    y2: 255.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__an",
    x1: 344.259,
    x2: 306.233,
    y1: 274.87,
    y2: 203.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ao",
    x1: 347.812,
    x2: 388.386,
    y1: 256.106,
    y2: 222.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ap",
    x1: 347.383,
    x2: 347.383,
    y1: 180.308,
    y2: 227.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aq",
    x1: 397.273,
    x2: 359.224,
    y1: 305.127,
    y2: 234.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ar",
    x1: 400.827,
    x2: 441.414,
    y1: 286.355,
    y2: 252.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__as",
    x1: 400.398,
    x2: 400.398,
    y1: 210.565,
    y2: 257.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__at",
    x1: 450.288,
    x2: 412.226,
    y1: 335.385,
    y2: 264.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__au",
    x1: 453.837,
    x2: 494.425,
    y1: 316.614,
    y2: 282.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__av",
    x1: 453.424,
    x2: 453.424,
    y1: 240.796,
    y2: 287.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aw",
    x1: 273.952,
    x2: 273.952,
    y1: 236.163,
    y2: 306.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ax",
    x1: 291.24,
    x2: 253.191,
    y1: 307.186,
    y2: 236.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ay",
    x1: 294.793,
    x2: 335.381,
    y1: 288.414,
    y2: 254.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__az",
    x1: 294.351,
    x2: 294.351,
    y1: 212.597,
    y2: 259.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aA",
    x1: 326.971,
    x2: 326.971,
    y1: 266.421,
    y2: 337.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aB",
    x1: 344.259,
    x2: 306.233,
    y1: 337.416,
    y2: 266.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aC",
    x1: 347.812,
    x2: 388.386,
    y1: 318.652,
    y2: 284.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aD",
    x1: 347.383,
    x2: 347.383,
    y1: 242.855,
    y2: 289.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aE",
    x1: 397.273,
    x2: 359.225,
    y1: 367.674,
    y2: 296.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aF",
    x1: 400.827,
    x2: 441.414,
    y1: 348.902,
    y2: 314.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aG",
    x1: 400.398,
    x2: 400.398,
    y1: 273.085,
    y2: 320.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aH",
    x1: 397.273,
    x2: 359.247,
    y1: 180.034,
    y2: 109.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aI",
    x1: 400.827,
    x2: 441.401,
    y1: 161.269,
    y2: 127.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aJ",
    x1: 400.398,
    x2: 400.398,
    y1: 85.472,
    y2: 132.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aK",
    x1: 450.288,
    x2: 412.226,
    y1: 210.291,
    y2: 139.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aL",
    x1: 453.837,
    x2: 494.425,
    y1: 191.52,
    y2: 157.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aM",
    x1: 453.424,
    x2: 453.424,
    y1: 115.702,
    y2: 162.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aN",
    x1: 503.325,
    x2: 465.276,
    y1: 240.549,
    y2: 169.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aO",
    x1: 506.878,
    x2: 547.461,
    y1: 221.777,
    y2: 187.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aP",
    x1: 506.436,
    x2: 506.436,
    y1: 145.96,
    y2: 193.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aQ",
    x1: 326.971,
    x2: 326.971,
    y1: 141.328,
    y2: 212.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aR",
    x1: 344.259,
    x2: 306.21,
    y1: 212.35,
    y2: 141.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aS",
    x1: 347.812,
    x2: 388.399,
    y1: 193.579,
    y2: 159.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aT",
    x1: 347.383,
    x2: 347.383,
    y1: 117.761,
    y2: 164.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aU",
    x1: 273.952,
    x2: 273.952,
    y1: 173.618,
    y2: 244.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aV",
    x1: 291.24,
    x2: 253.191,
    y1: 244.64,
    y2: 173.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aW",
    x1: 294.793,
    x2: 335.381,
    y1: 225.869,
    y2: 191.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aX",
    x1: 294.351,
    x2: 294.351,
    y1: 150.051,
    y2: 197.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aY",
    x1: 400.278,
    x2: 400.278,
    y1: 440.282,
    y2: 37.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060E41",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#060E41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__aZ",
    x1: 775.705,
    x2: 775.705,
    y1: 552.353,
    y2: 629.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__ba",
    x1: 753.822,
    x2: 798.252,
    y1: 609.549,
    y2: 572.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__bb",
    x1: 758.616,
    x2: 733.963,
    y1: 613.797,
    y2: 543.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__bc",
    x1: 734.418,
    x2: 734.418,
    y1: 468.65,
    y2: 543.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__bd",
    x1: 792.624,
    x2: 782.132,
    y1: 562.67,
    y2: 503.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hero_svg__be",
    x1: 751.712,
    x2: 790.347,
    y1: 517.658,
    y2: 477.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })))));
};
export default SvgHero;